import currencySymbol from '../../../lib/currencySymbol'
import { isJustGiving } from '../../../lib/environment'
import { edhLogo, jgLogo } from '../../../assets'

const logoImage = () => isJustGiving() ? jgLogo : edhLogo

export default ({
  country,
  uom
}, {
  colors,
  rhythm,
  scale,
  treatments
}) => ({
  providers: {
    marginBottom: rhythm(1)
  },
  provider: {
    marginBottom: rhythm(0.75),
    borderColor: 'transparent'
  },
  heading: {
    fontSize: scale(2)
  },
  form: {
    root: {
      paddingBottom: rhythm(0.5),
      '& button[type="submit"]:before': {
        content: '""',
        display: 'inline-block',
        position: 'static',
        opacity: '1',
        marginRight: rhythm(0.5),
        verticalAlign: 'middle',
        width: rhythm(1),
        height: rhythm(1),
        backgroundColor: 'transparent',
        backgroundImage: `url(${logoImage()})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }
    }
  },
  createPageForm: {
    root: {
      paddingBottom: rhythm(0.5)
    }
  },
  target: {
    root: {
      position: 'relative',
      '&:before': {
        content: `"${currencySymbol(country)}"`,
        position: 'absolute',
        top: rhythm(1.175),
        left: 0,
        width: rhythm(1.125),
        height: rhythm(1.666),
        paddingRight: rhythm(0.25),
        lineHeight: rhythm(1.666),
        textAlign: 'right',
        opacity: 0.5,
        whiteSpace: 'nowrap',
        pointerEvents: 'none'
      }
    },
    field: {
      paddingLeft: rhythm(1.125)
    }
  },
  fitnessGoal: {
    root: {
      position: 'relative',
      '&:before': {
        content: `"${uom}"`,
        position: 'absolute',
        top: rhythm(1.175),
        right: 0,
        width: rhythm(1.75),
        height: rhythm(1.666),
        paddingLeft: rhythm(0.25),
        lineHeight: rhythm(1.666),
        opacity: 0.5,
        whiteSpace: 'nowrap',
        pointerEvents: 'none'
      }
    },
    field: {
      textAlign: 'right',
      paddingRight: rhythm(1.75)
    }
  },
  label: {
    fontWeight: 'inherit',
    display: 'inline-block',
    '& p': {
      display: 'inline-block'
    }
  },
  termsLabel: {
    display: 'inline-block',
    '& p': {
      display: 'inline-block'
    }
  },
  termsCheckbox: {
    root: {
      order: 99
    }
  },
  copy: {
    marginBottom: rhythm(1)
  },
  link: {
    marginTop: rhythm(0.5),
    border: 0,
    opacity: 0.85,
    fontSize: scale(-0.5)
  }
})



// WEBPACK FOOTER //
// ./components/slices/Registration/styles.js